import { Divider, message, Select, Space } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    ModalItem,
    round10Decimals,
    ButtonItem,
    ErrorItem,
    TableItem,
    SelectItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import AgregarAgrupacion from "../../Agrupaciones/AgregarAgrupacion/AgregarAgrupacion";

const { Option } = Select;

class AgregarLoteAProcesos extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasLotes: [],
        clienteId: null,
        insumoId: null,
        objetoClientes: null,
        objetoInsumos: null,
        objetoEtapas: null,
        agrupacionesElegidas: [],
        modalAgregarAgrupacion: false,
        modalAgregarAgrupacionLoteId: null,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInsumosClientes()
        }
    }

    cerrarAgregarLoteAProcesos() {
        this.setState({
            loading: false,
            todasLotes: [],
            clienteId: null,
            insumoId: null,
            objetoClientes: null,
            objetoInsumos: null,
            objetoEtapas: null,
            agrupacionesElegidas: [],
            modalAgregarAgrupacion: false,
            modalAgregarAgrupacionLoteId: null,
        });
        this.formRef.current.resetFields()
        this.props.cerrarAgregarLoteAProcesos();
    }

    consultarInsumosClientes() {
        this.setState({ loading: true });
        axios
            .post(
                "procesos/selectInsumosClientesEtapas",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const insumos = res.data.insumos.map((insumo) => (
                        <Option key={insumo._id} value={insumo._id}>
                            {insumo.stringBuscar}
                        </Option>
                    ));
                    const clientes = res.data.clientes.map((cliente) => (
                        <Option key={cliente._id} value={cliente._id}>
                            {cliente.stringBuscar}
                        </Option>
                    ));
                    const etapas = res.data.etapas.map((etapa) => (
                        <Option key={etapa._id} value={etapa._id}>
                            {etapa.nombre}
                        </Option>
                    ));
                    this.setState({
                        objetoInsumos: insumos,
                        objetoClientes: clientes,
                        objetoEtapas: etapas,
                    }, () => {
                        this.consultarLotesDisponibles();
                    });
                } else if (res.data.success === 1) {
                    this.setState({ loading: false });
                    message.warning(res.data.message);
                } else {
                    this.setState({ loading: false });
                    message.error("Hubo un error al consultar insumos y clientes.");
                }
            })
    }

    async consultarLotesDisponibles(valores) {
        this.setState({ loading: true });
        await axios
            .post(
                "procesos/selectlotesDisponibles",
                {
                    empresaId: this.props.empresaId,
                    clienteId: valores?.clienteId,
                    insumoId: valores?.insumoId,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({ todasLotes: res.data.lotesDisponibles });
                } else if (res.data.success === 1) {
                    message.warning(res.data.message)
                } else {
                    message.error('Hubo un error y no se pudo consultar los marbetes disponibles')
                }
            });
        this.setState({ loading: false });
    }

    onFinish(values) {
        if (!values.etapaId) return message.warning("Debe seleccionar una etapa.");
        if (this.state.agrupacionesElegidas.length === 0) return message.warning("Debe agregar al menos un lote.");

        this.setState({ loading: true });
        axios.post(
            "procesos/agregarAgrupacionAProcesos",
            {
                empresaId: this.props.empresaId,
                etapaId: values.etapaId,
                agrupacionesElegidas: this.state.agrupacionesElegidas,
            },
            {
                headers: this.props.headersToken,
            }
        ).then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
                message.success("Agrupaciones agregadas correctamente.");
                this.cerrarAgregarLoteAProcesos();
            } else if (res.data.success === 1) {
                message.warning(res.data.message);
            } else {
                message.error("Hubo un error al agregar las agrupaciones.");
            }
        }).catch((error) => {
            this.setState({ loading: false });
            console.error("Error al agregar agrupaciones:", error);
            message.error("Hubo un error al agregar las agrupaciones.");
        });
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    agregarLote(record) {
        this.setState({
            loading: true,
            modalAgregarAgrupacion: true,
            modalAgregarAgrupacionLoteId: record._id,
        });

    }

    cerrarAgregarAgrupacion(agregado, agrupacionAgregada) {
        if (agregado && agrupacionAgregada) {
            const agrupacionesElegidas = [...this.state.agrupacionesElegidas]
            agrupacionesElegidas.push(agrupacionAgregada);
            this.setState({
                loading: false,
                agrupacionesElegidas: agrupacionesElegidas,
                modalAgregarAgrupacion: false,
                modalAgregarAgrupacionLoteId: null,
            })
            this.consultarLotesDisponibles({
                insumoId: this.state.insumoId,
                clienteId: this.state.clienteId,
            })
        } else {
            this.setState({
                loading: false,
                modalAgregarAgrupacion: false,
                modalAgregarAgrupacionLoteId: null,
            });
        }
    }


    agregarAgrupacion(record) {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas];
        if (!agrupacionesElegidas.some(lote => lote._id === record._id)) {
            agrupacionesElegidas.push(record);
            this.setState({ agrupacionesElegidas });
        } else {
            message.warning("El lote ya ha sido agregado a la lista.");
        }
    }

    eliminarAgrupacion(record) {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas].filter(lote => lote._id !== record._id);
        this.setState({ agrupacionesElegidas });
    }

    render() {
        const columns = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Fecha",
                dataIndex: "createdAt",
                responsive: ["md"],
                key: "createdAt",
                render: (value) => moment(value).locale("es").format("ll"),
                width: "10%",
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                responsive: ["md"],
                key: "concepto",
                width: "20%",
                render: (value, record) => {
                    if (record.agrupacion) {
                        return "Agrupación" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }

                    if (record.lote) {
                        return "Lote" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }
                }
            },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                responsive: ["md"],
                key: "clienteNombre",
                width: "15%",
                buscar: "clienteNombre",
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "5%",
            },
            {
                title: "Saldo",
                dataIndex: "saldo",
                key: "saldo",
                sorter: (a, b) => {
                    if (a.saldo < b.saldo) {
                        return -1;
                    }
                    if (a.saldo > b.saldo) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "10%",
            },
            {
                title: "Accion",
                key: "accion",
                render: (value, record, index) => {

                    if (record.lote) {
                        return (
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    onClick={() => {
                                        this.agregarLote(record);
                                    }}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Agregar
                                </ButtonItem>
                            </Space>
                        )
                    }

                    if (record.agrupacion) {
                        return (
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    onClick={() => {
                                        this.agregarAgrupacion(record);
                                    }}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Agregar
                                </ButtonItem>
                            </Space>
                        )
                    }
                },
                width: "10%",
            }
        ];
        const columnsElegido = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Fecha",
                dataIndex: "createdAt",
                responsive: ["md"],
                key: "createdAt",
                render: (value) => moment(value).locale("es").format("ll"),
                width: "10%",
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                responsive: ["md"],
                key: "concepto",
                width: "20%",
                render: (value, record) => {
                    if (record.agrupacion) {
                        return "Agrupación" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }

                    if (record.lote) {
                        return "Lote" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }
                }
            },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                responsive: ["md"],
                key: "clienteNombre",
                width: "15%",
                buscar: "clienteNombre",
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "5%",
            },
            {
                title: "Saldo",
                dataIndex: "saldo",
                key: "saldo",
                sorter: (a, b) => {
                    if (a.saldo < b.saldo) {
                        return -1;
                    }
                    if (a.saldo > b.saldo) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "10%",
            },
            {
                title: "Accion",
                key: "accion",
                responsive: ["md"],
                render: (value, record, index) => (
                    <Space>
                        <ButtonItem
                            type="primary"
                            onClick={() => {
                                this.eliminarAgrupacion(record);
                            }}
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            rojo
                        >
                            Eliminar
                        </ButtonItem>
                    </Space>
                ),
                width: "10%",
            }
        ];
        return (
            <>
                <ModalItem
                    title="Agregar Lote a Proceso"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarLoteAProcesos.bind(this)}
                    paddingTop
                    width={1200}
                >
                    <Form
                        ref={this.formRef}
                        name="agregarLoteAProcesos"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            label="Etapa"
                            name="etapaId"
                            margin
                            required
                        >
                            <SelectItem
                                placeholder="Etapa"
                            >
                                {this.state.objetoEtapas}
                            </SelectItem>
                        </FormItem>
                        <Divider>Lotes Elegidos</Divider>
                        <TableItem
                            size="small"
                            dataSource={this.state.agrupacionesElegidas}
                            columns={columnsElegido}
                            pagination={false}
                            locale={{
                                emptyText: "No hay lotes elegidos. Doble click en un lote para agregarlo.",
                            }}
                            onRow={(record, rowIndex) => {
                                return {
                                    onDoubleClick: (event) => {
                                        this.agregarLote(record);
                                    },
                                };
                            }}
                        />
                        <Divider>Filtros</Divider>
                        <FormItem
                            label="Insumo"
                            margin
                        >
                            <SelectItem
                                placeholder="Insumo"
                                allowClear
                                onChange={(value) => {
                                    this.setState({ insumoId: value });
                                    this.consultarLotesDisponibles({ insumoId: value, clienteId: this.state.clienteId });
                                }}
                                value={this.state.insumoId}
                            >
                                {this.state.objetoInsumos}
                            </SelectItem>
                        </FormItem>
                        <FormItem
                            label="Cliente"
                            margin
                        >
                            <SelectItem
                                placeholder="Cliente"
                                allowClear
                                onChange={(value) => {
                                    this.setState({ clienteId: value });
                                    this.consultarLotesDisponibles({ clienteId: value, insumoId: this.state.insumoId });
                                }}
                                value={this.state.clienteId}
                            >
                                {this.state.objetoClientes}
                            </SelectItem>
                        </FormItem>
                        <Divider>Lotes Disponibles</Divider>
                        <TableItem
                            size="small"
                            dataSource={this.state.todasLotes}
                            columns={columns}
                            pagination={false}
                            onRow={(record, rowIndex) => {
                                return {
                                    onDoubleClick: (event) => {
                                        this.agregarLote(record);
                                    },
                                };
                            }}
                        />
                    </Form>
                    <AgregarAgrupacion
                        visible={this.state.modalAgregarAgrupacion}
                        cerrarAgregarAgrupacion={this.cerrarAgregarAgrupacion.bind(this)}
                        loteId={this.state.modalAgregarAgrupacionLoteId}
                        headersToken={this.props.headersToken}
                        empresaId={this.props.empresaId}
                        noMostrarDatos
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarLoteAProcesos);
